import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BsController } from "react-icons/bs";
import { FaBriefcase, FaHeart, FaQuestionCircle, FaTicketAlt, FaUserCircle, FaWallet, FaWpforms } from "react-icons/fa";
import { FiBell, FiHeadphones, FiMapPin, FiRefreshCcw, FiSearch, FiShield, FiStar } from "react-icons/fi";
import { HiOutlineFilm, HiOutlineHome } from "react-icons/hi2";
import { MdOutlineApps, MdOutlineEvent, MdOutlineLocalOffer, MdOutlineShoppingBag, MdOutlineSportsCricket } from "react-icons/md";
import logoWithName from "../../Images/logowithname.png";
import DesktopUserChip from "./DesktopUserChip";

const pageMenuItems = [
    { label: "Home", icon: HiOutlineHome, path: "/" },
    { label: "Events", icon: MdOutlineEvent, path: "/" },
    { label: "Movies", icon: HiOutlineFilm, path: "/" },
    { label: "Sports", icon: MdOutlineSportsCricket, path: "/" },
    { label: "Games", icon: BsController, path: "/" },
    { label: "Shopping", icon: MdOutlineShoppingBag, path: "/" },
    { label: "Offers", icon: MdOutlineLocalOffer, path: "/" },
    { label: "Bookings", icon: FaTicketAlt, path: "/booking" },
    { label: "Favorites", icon: FaHeart, path: "/favorite" },
    { label: "eWallet", icon: FaWallet, path: "/wallet" },
    { label: "Profile", icon: FaUserCircle, path: "/profile" },
    { label: "FAQ", icon: FaQuestionCircle, path: "/faq" },
    { label: "Forms", icon: FaWpforms, path: "/form-list" },
    { label: "Business", icon: FaBriefcase, path: "/business-user" },
    { label: "More", icon: MdOutlineApps, path: "/" },
];

const mobileMenuItems = [
    { label: "Home", icon: HiOutlineHome, path: "/", matchPaths: ["/"] },
    { label: "Forms", icon: FaWpforms, path: "/form-list", matchPaths: ["/form-list", "/form"] },
    { label: "Business", icon: FaBriefcase, path: "/business-user", matchPaths: ["/business-user"] },
    { label: "More", icon: MdOutlineApps, path: "/", matchPaths: [] },
];

const ThemedPageFrame = ({ activePath, eyebrow, title, subtitle, summary, children, className = "" }) => {
    const navigate = useNavigate();

    useEffect(() => {
        document.body.classList.add("desktop-home-active");
        return () => document.body.classList.remove("desktop-home-active");
    }, []);

    const handleNavigate = (path) => {
        if (path) {
            navigate(path);
        }
    };

    return (
        <div className={`nabhiverse_desktop_home themed_page_layout ${className}`}>
            <aside className="desktop_home_sidebar">
                <div className="desktop_home_logo">
                    <img src={logoWithName} alt="Nabhiverse" />
                </div>
                <nav className="desktop_home_nav themed_page_nav">
                    {pageMenuItems.map((item) => {
                        const Icon = item.icon;
                        const isActive = activePath === item.path || title === item.label;

                        return (
                            <button
                                key={item.label}
                                className={`desktop_home_nav_item ${isActive ? "active" : ""}`}
                                type="button"
                                onClick={() => handleNavigate(item.path)}
                            >
                                <Icon />
                                <span>{item.label}</span>
                            </button>
                        );
                    })}
                </nav>
                <div className="desktop_home_star_box">
                    <FiStar />
                    <span>nabi star</span>
                    <strong>Your Stars 620</strong>
                    <button type="button">View Benefits</button>
                </div>
                <div className="desktop_home_help_box">
                    <FiHeadphones />
                    <span>Need Help?</span>
                    <p>24x7 Support</p>
                    <button type="button">Contact Us</button>
                </div>
            </aside>

            <main className="desktop_home_main themed_page_main">
                <header className="desktop_home_topbar themed_page_topbar">
                    <div className="mobile_header_logo">
                        <img src={logoWithName} alt="Nabhiverse" />
                    </div>
                    <div className="desktop_search_box">
                        <FiSearch />
                        <input type="text" placeholder="Search for apps, services, movies, events and more..." readOnly />
                    </div>
                    <div className="desktop_location"><FiMapPin /> Bengaluru</div>
                    <DesktopUserChip />
                    <button className="desktop_bell_btn" type="button" aria-label="Notifications">
                        <FiBell />
                        <span>3</span>
                    </button>
                </header>

                <section className="themed_page_shell">
                    <div className="themed_page_hero">
                        <div>
                            {eyebrow && <span className="themed_page_eyebrow">{eyebrow}</span>}
                            <h1>{title}</h1>
                            {subtitle && <p>{subtitle}</p>}
                        </div>
                        {summary && <div className="themed_page_summary">{summary}</div>}
                    </div>
                    {children}
                </section>

                <footer className="desktop_home_footer themed_page_footer">
                    <img src={logoWithName} alt="Nabhiverse" />
                    <span><FiShield /> Fast & Secure Payments</span>
                    <span><FiRefreshCcw /> Easy Returns</span>
                    <span><FiHeadphones /> 24x7 Support</span>
                    <p>(c) 2026 Nabhiverse. All Rights Reserved.</p>
                </footer>
            </main>

            <nav className="mobile_bottom_menu">
                {mobileMenuItems.map((item) => {
                    const Icon = item.icon;
                    const isFixedPage = mobileMenuItems.some((menuItem) =>
                        menuItem.label !== "More" && menuItem.matchPaths?.some((path) => activePath === path || (path !== "/" && activePath?.startsWith(path)))
                    );
                    const isActive = item.label === "More"
                        ? !isFixedPage
                        : item.matchPaths?.some((path) => activePath === path || (path !== "/" && activePath?.startsWith(path)));

                    return (
                        <button
                            key={item.label}
                            type="button"
                            className={isActive ? "active" : ""}
                            onClick={() => handleNavigate(item.path)}
                        >
                            <Icon />
                            <span>{item.label}</span>
                        </button>
                    );
                })}
            </nav>
        </div>
    );
};

export default ThemedPageFrame;
